import { useUserQuery } from "../../networking/user/queries"

const useAdmin = () => {
  const { data: user } = useUserQuery()
  return user?.id === 1458884
}

export default useAdmin
